module.exports = __webpack_public_path__ + "6fb2360528888d0fbb56193f1c66aa3a.png";